import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { FaqsService } from '../../services/faqs.service';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { GoogleAnalyticsService } from '../../services/google-analytics.service';
import { SearchPipe } from '../../pipes/search.pipe';
import { arrayIsDefinedAndEmpty } from '../../shared/array-functions';
import { helpView } from '../help/help.static.data';

@Component({
  selector: 'app-faqs',
  templateUrl: './faqs.component.html',
  styleUrls: ['../../app.component.css']
})
export class FaqsComponent implements OnInit, AfterViewInit, OnDestroy {
  selectedCategory: string;
  selectedFaq: object;
  toggleFaq: boolean;
  searchText: string;
  allQuestionsSelected: boolean;
  noSearchResults: boolean;
  searchSubscription: Subscription;
  helpView: any;

  constructor(public faqsService: FaqsService, private route: ActivatedRoute, private router: Router, public googleAnalyticsService: GoogleAnalyticsService) {
    this.helpView = helpView;
    this.scrollToTop();
   }

  ngOnInit() {
    this.searchSubscription = this.route.queryParams.subscribe(params => {
      this.searchText = params['search'] || ''; // Set to empty string if no query parameter is provided
      this.searchText !== '' ? this.searchFAQs(this.searchText) : '';
    });
  }

  ngAfterViewInit(): void {
   this.scrollToTop();
  }

  ngOnDestroy() {
    this.searchSubscription.unsubscribe();
    this.faqsService.getCategories();
  }

  getAllFaqs() {
    this.searchText = '';
    this.selectedCategory = null;
    this.allQuestionsSelected = true;
    this.noSearchResults = false;
    this.faqsService.faqs = this.faqsService.allFaqs;
    this.submitGAEvent('Preguntas_Frecuentes_SAM', 'Click', 'Todas_Las_Preguntas');
  }

  getFaqsByCategory(category) {
    this.allQuestionsSelected = false;
    this.noSearchResults = false;
    this.searchText = '';
    this.selectedCategory = category.name;
    this.faqsService.getFaqsByCategoryId(category.id);
    this.submitGAEvent('Preguntas_Frecuentes_SAM', 'Click_Category', category.slug);
    window.scrollTo(0, 0);
  }

  selectFaq(faq) {
    if (this.selectedFaq === faq) {
      this.toggleFaq = !this.toggleFaq;
      this.selectedFaq = faq;
    } else {
      this.toggleFaq = true;
      this.selectedFaq = faq;
    }
    this.submitGAEvent('Preguntas_Frecuentes_SAM', 'Click_Question', faq.slug);
  }

  searchFAQs(value: string) {
    this.selectedCategory = null;
    this.allQuestionsSelected = false;
    const result = new SearchPipe().transform(this.faqsService.allFaqs, this.searchText);
    if (arrayIsDefinedAndEmpty(result)) {
      this.noSearchResults = true;
    } else {
      this.faqsService.faqs = result;
      this.noSearchResults = false;
    }
  }

  submitGAEvent(eventCategory, eventAction, eventLabel) {
    this.googleAnalyticsService.emitEvent(eventCategory, eventAction, eventLabel, null);
  }

  scrollToTop() {
    this.router.events.subscribe((event: NavigationEnd) => {
      if(event instanceof NavigationEnd) {
        window.scrollTo(0, 0);
      }
    });
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src4156872633/src/src/app/components/faqs/faqs.component.ts